import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { fromJS, Map, List } from 'immutable';
import AnimateHeight from 'react-animate-height';
import PropTypes from 'prop-types';
import { color, size, animation } from '../styles/helpers/variables';
import { selectedBackground } from '../styles/helpers/mixins';
import connect from '../store/connect';
import CustomSelect from '../components/CustomSelect';

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.setActive = this.setActive.bind(this);
  }

  setActive() {
    this.setState({
      active: !this.state.active
    });
  }

  desktopLinkListRender(isMobile) {
    return this.props.footerMenu
      .map((item, index) => {
        const siteInFooter = this.props.location.pathname.indexOf(item.get('url')) !== -1;
        const isSelected = this.props.location.pathname === item.get('url');
        return (
          <div key={index}>
            <HeadingParagraph>
              <SideDetailLink selected={isSelected} to={item.get('url')}>
                {item.get('title')}
              </SideDetailLink>
            </HeadingParagraph>
            <SideLinks>
              {!isMobile ? (
                <AnimateHeight
                  className="animation"
                  duration={400}
                  easing="ease-out"
                  height={siteInFooter ? 'auto' : 0}
                >
                  {this.renderChildLinks(item)}
                </AnimateHeight>
              ) : (
                this.renderChildLinks(item)
              )}
            </SideLinks>
          </div>
        );
      })
      .toArray();
  }

  renderChildLinks(item) {
    return item.get('children').map((child, childIndex) => {
      const isChildSelected = this.props.location.pathname === child.get('url');
      return (
        <li key={childIndex}>
          <SideDetailChildLink selected={isChildSelected} to={child.get('url')}>
            {child.get('title')}
          </SideDetailChildLink>
        </li>
      );
    });
  }

  render() {
    // check if page is part of footermenu
    const siteInFooter = !!this.props.footerMenu.filter(
      item => this.props.location.pathname.indexOf(item.get('url')) !== -1
    ).size;
    if (!siteInFooter) {
      return false;
    }

    const { viewstate } = this.props;
    const isMobile = viewstate.get('pageWidth') < size.xLarge;
    const footerDataMobile = this.desktopLinkListRender(true);
    const footerDataDesktop = this.desktopLinkListRender(false);

    if (isMobile) {
      return (
        <CustomSelect title={this.props.currentPage.getIn(['fields', 'title'])}>
          <SideMenuContainer>{footerDataMobile}</SideMenuContainer>
        </CustomSelect>
      );
    }
    return <SideMenuContainer>{footerDataDesktop}</SideMenuContainer>;
  }
}

const HeadingParagraph = styled.p`
  margin-top: 0;
  margin-bottom: 5px;
`;

const SideDetailLink = styled(Link)`
  color: ${color.black};
  text-decoration: none;
  padding: 2px 0;
  margin-bottom: 14px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-align: left;
  padding-left: 0;
  margin-left: 15px;
  white-space: nowrap;
  transition: opacity 250ms ease-out;

  &:hover {
    opacity: 0.8;
  }
  ${selectedBackground()} &:before {
    opacity: 0;
    transition: opacity ${animation.transitionTime} ${animation.easing};
  }
  ${props =>
    props.selected &&
    css`
      &:before {
        opacity: 1;
      }
    `};
`;

const SideDetailChildLink = styled(Link)`
  color: ${color.black};
  text-decoration: none;
  padding: 2px 0;
  white-space: nowrap;
  transition: opacity 250ms ease-out;
  &:hover {
    opacity: 0.8;
  }
  ${selectedBackground()} &:before {
    opacity: 0;
    transition: opacity ${animation.transitionTime} ${animation.easing};
  }
  ${props =>
    props.selected &&
    css`
      &:before {
        opacity: 1;
      }
    `};
`;

const SideLinks = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-left: 15px;
  margin: 10px 0 5px;
  color: ${color.white};

  li {
    margin-bottom: 5px;
    text-align: left;
    padding: 0;
    font-size: 13px;
    line-height: 2;
    color: ${color.black};
    padding-left: 30px;
  }
`;

const SideMenuContainer = styled.div`
  border-top: 1px solid grey;
  padding-top: 10px;
  width: 100%;
  margin: 0 auto;
  @media screen and (min-width: ${size.xLarge}px) {
    width: 400px;
    margin-left: 60px;
    margin-top: 20px;
    border: none;
    padding-top: 0;
  }
  @media screen and (min-width: ${size.articleSideMenuBreakPoint}px) {
    width: 230px;
    margin: 0 -250px 0 0;
  }
  @media screen and (min-width: ${size.articleSideMenuWideBreakPoint}px) {
    margin: 0 -280px 0 0;
  }
`;

SideMenu.defaultProps = {
  viewstate: Map(),
  footerMenu: List(),
  currentPage: Map()
};

SideMenu.propTypes = {
  location: PropTypes.object.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  footerMenu: PropTypes.instanceOf(List),
  currentPage: PropTypes.instanceOf(Map)
};

export default connect(SideMenu, {}, (store, props) => ({
  viewstate: store.viewstate,
  currentPage: store.page.data.get(props.location.pathname, Map()),
  footerMenu: fromJS((window.startup || {}).footerLinks)
}));



// WEBPACK FOOTER //
// ./src/components/SideMenu.js